import DisplayFile from './DisplayFile'

export default DisplayFile
